import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub';
import { SidebarMenuItem } from './SidebarMenuItem';
import { SidebarMenuTemplateItem } from './SidebarMenuTemplateItem';

const SidebarMenuMain = () => {
  return (
    <>
      <SidebarMenuItem
        to='/user-management/users'
        title='User Management'
        fontIcon='bi-people'
        icon='people'
      />

      <SidebarMenuItemWithSub to='/pages' title='Pages' fontIcon='bi-archive' icon='element-plus' defaultOpen={true}>
        <SidebarMenuItem to='/pages/navbar' title='Navbar' hasBullet={false} />
        <SidebarMenuItem to='/pages/footer' title='Footer' hasBullet={false} />

        <SidebarMenuItemWithSub to='/pages/home' title='Home' hasBullet={false}>
          <SidebarMenuItem to='/pages/home/heroCarousel' title='Hero Carousel' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/intro' title='Community Map and News' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/partners' title='Partners' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/about' title='About' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/client' title='Client' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/community' title='Community' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/news' title='News' hasBullet={true} />
          <SidebarMenuItem to='/pages/home/report' title='Report' hasBullet={true} />
        </SidebarMenuItemWithSub>

        {/* About section hidden — content migrated to New Pages
        <SidebarMenuItemWithSub to='/pages/about' title='About' hasBullet={false}>
          <SidebarMenuItem to='/pages/about/hero' title='Hero' hasBullet={true} />
          <SidebarMenuItem to='/pages/about/visionTop' title='Vision-top' hasBullet={true} />
          <SidebarMenuItem to='/pages/about/visionBottom' title='Vision-bottom' hasBullet={true} />
          <SidebarMenuItem to='/pages/about/report' title='Report' hasBullet={true} />
          <SidebarMenuItem to='/pages/about/teams' title='Teams' hasBullet={true} />
        </SidebarMenuItemWithSub>
        */}

        <SidebarMenuTemplateItem to='/pages/template/template' title='New Pages' hasBullet={false}></SidebarMenuTemplateItem>

        <SidebarMenuItem to='/pages/blog' title='Blog' hasBullet={false}></SidebarMenuItem>
        <SidebarMenuItemWithSub to='/pages/contact' title='Contact' hasBullet={false}>
          <SidebarMenuItem to='/pages/contact/background' title='Background' hasBullet={true} />
          <SidebarMenuItem to='/pages/contact/form' title='Form' hasBullet={true} />
        </SidebarMenuItemWithSub>





      </SidebarMenuItemWithSub>
    </>
  );
};

export { SidebarMenuMain };
